import {BasicModalProps} from "../../interfaces/BasicModalProps";
import {Modal} from "react-bootstrap";
import SecondaryButton from "../../atom/buttons/SecondaryButton";
import DangerButton from "../../atom/buttons/DangerButton";
import client from "../../../../axios";
import {useState} from "react";

interface DeleteAccountModalProps extends BasicModalProps {
  deletingUsrNo: string;
  getData(): void;
}

export default function DeleteAccountModal(props: DeleteAccountModalProps) {

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  function handleCancel() {
    props.setShow(false);
  }

  async function handleDeleteAccount() {
    if (props.deletingUsrNo.length !== 0) {
      try {
        setIsDeleting(true);
        await client.delete('/api/master/account', { params: { usrNo: props.deletingUsrNo } });
        props.setShow(false);
        setTimeout(() => {
          setShowSuccessModal(true);
          props.getData()
        }, 200);
      } catch (e) {
        props.setShow(false);
        setTimeout(() => setShowErrorModal(true), 200);
      } finally {
        setIsDeleting(false);
      }
    }
  }

  return (
    <>
      <Modal show={props.show} centered>
        <Modal.Body>
          정말 삭제하시겠습니까?
        </Modal.Body>
        <Modal.Footer>
          <SecondaryButton onClick={handleCancel}>
            취소
          </SecondaryButton>
          <DangerButton onClick={handleDeleteAccount} disabled={isDeleting}>
            삭제
          </DangerButton>
        </Modal.Footer>
      </Modal>

      <Modal show={showSuccessModal} centered>
        <Modal.Body>
          계정을 성공적으로 삭제하였습니다.
        </Modal.Body>
        <Modal.Footer>
          <SecondaryButton onClick={() => setShowSuccessModal(false)}>
            닫기
          </SecondaryButton>
        </Modal.Footer>
      </Modal>

      <Modal show={showErrorModal} centered>
        <Modal.Body>
          계정 삭제에 실패하였습니다.
        </Modal.Body>
        <Modal.Footer>
          <SecondaryButton onClick={() => setShowErrorModal(false)}>
            닫기
          </SecondaryButton>
        </Modal.Footer>
      </Modal>
    </>
  )
}